import { getConnectivity } from '@datadog/browser-core';
export function startConnectivityContext(hooks) {
  hooks.register(0
  /* HookNames.Assemble */
  , function (_ref) {
    var eventType = _ref.eventType;
    return {
      type: eventType,
      connectivity: getConnectivity()
    };
  });
}